var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VText',_vm._b({staticClass:"settings-section__title",attrs:{"component":"h2","variant":"h3"}},'VText',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }